import { NoData } from '@components/NoData'
import { Pagination } from '@components/Pagination'
import { PenNameTableProps } from './interface'

export function PenNameTable({
  page,
  perpage,
  total,
  data,
  isLoading,
  pageChange,
  handleSort,
  Table,
}: PenNameTableProps) {
  return (
    <div>
      <Table
        isLoading={isLoading}
        onSort={handleSort}
        bodyClassName='border-b border-gray text-[14px] font-light text-secondary hover:bg-blue-4/10'
      />
      <div className='mt-[30px]'>
        <Pagination
          page={page}
          perpage={perpage}
          total={total}
          pageChange={pageChange}
        />
      </div>
    </div>
  )
}
